/*!
 * Copyright © 2005-2024 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Alfresco Example Content Application
 *
 * This file is part of the Alfresco Example Content Application.
 * If the software was purchased under a paid Alfresco license, the terms of
 * the paid license agreement will prevail. Otherwise, the software is
 * provided under the following open source license terms:
 *
 * The Alfresco Example Content Application is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Lesser General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * The Alfresco Example Content Application is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Lesser General Public License for more details.
 *
 * You should have received a copy of the GNU Lesser General Public License
 * from Hyland Software. If not, see <http://www.gnu.org/licenses/>.
 */

import { Action } from '@ngrx/store';
import { Node } from '@alfresco/js-api';

export const CREATE_PDF_ACTION = 'CREATE_PDF_ACTION';
export const MOVE_JOBDOCUMENT_ACTION = 'MOVE_JOBDOCUMENT_ACTION';
export const JOBDOCUMENT_VIEWINTAB_ACTION = 'JOBDOCUMENT_VIEWINTAB_ACTION';
export const UPLOAD_JOBDOCUMENT_FILES_ACTION = 'UPLOAD_JOBDOCUMENT_FILES_ACTION';
export const JOBDOCUMENT_OPEN_WITH_BLUEBEAM_ACTION = 'JOBDOCUMENT_OPEN_WITH_BLUEBEAM_ACTION';
export const COPY_JOBDOCUMENT_ACTION = 'COPY_JOBDOCUMENT_ACTION';

export class CreatePdfAction implements Action {
  readonly type = CREATE_PDF_ACTION;
  constructor(public payload: Node) {}
}

export class MoveJobdocumentAction implements Action {
  readonly type = MOVE_JOBDOCUMENT_ACTION;
  constructor(public payload: Node) {}
}

export class ViewInTabAction implements Action {
  readonly type = JOBDOCUMENT_VIEWINTAB_ACTION;
  constructor(public payload: Node) {}
}

export class UploadJobDocumentsFilesAction implements Action {
  readonly type = UPLOAD_JOBDOCUMENT_FILES_ACTION;
  constructor(public payload: any) {}
}

export class OpenWithBluebeamAction implements Action {
  readonly type = JOBDOCUMENT_OPEN_WITH_BLUEBEAM_ACTION;
  constructor(public payload: Node) {}
}


export class CopyJobdocumentAction implements Action {
  readonly type = COPY_JOBDOCUMENT_ACTION;
  constructor(public payload: Node) {}
}



